(function () {
  'use strict';
  var bar = document.querySelector('[data-tierbar]');
  if (!bar) return;
  var tiers = (bar.getAttribute('data-tiers') || '').split(',').map(function (t) {
    var p = t.split(':'); return { q: parseInt(p[0], 10), a: parseInt(p[1], 10) };
  }).filter(function (t) { return t.q > 0 && t.a > 0; }).sort(function (a, b) { return a.q - b.q; });
  if (!tiers.length) { bar.hidden = true; return; }
  var max = tiers[tiers.length - 1].q;
  var msg = bar.querySelector('[data-tier-msg]'), fill = bar.querySelector('[data-tier-fill]');
  var ticks = [].slice.call(bar.querySelectorAll('[data-tick]'));
  var counter = document.querySelector('[data-cart-count]');
  function count() { return counter ? (parseInt(counter.textContent, 10) || 0) : 0; }
  function render() {
    var n = count(), reached = null, next = null;
    fill.style.width = Math.min(100, n / max * 100) + '%';
    tiers.forEach(function (t) { if (n >= t.q) reached = t; else if (!next) next = t; });
    if (!reached && next) {
      var l = next.q - n;
      msg.innerHTML = 'Add <b>' + l + '</b> more item' + (l > 1 ? 's' : '') + ' to get <b>&#8377;' + next.a + ' OFF</b>';
    } else if (reached && next) {
      msg.innerHTML = '&#8377;' + reached.a + ' OFF unlocked! Add <b>' + (next.q - n) + '</b> more for <b>&#8377;' + next.a + ' OFF</b>';
    } else if (reached) {
      msg.innerHTML = 'You unlocked the best offer: <b>&#8377;' + reached.a + ' OFF</b>';
    }
    ticks.forEach(function (el) { el.classList.toggle('is-on', n >= parseInt(el.getAttribute('data-tick'), 10)); });
    bar.classList.toggle('is-done', !next);
  }
  if (counter) new MutationObserver(render).observe(counter, { childList: true, characterData: true, subtree: true });
  render();
})();
